<template>
  <div class="bd">
<!--    中机科展示-->
    <ul class="newslist" v-if="stations.id == 1004">
    <!--  展示表格-->
      <el-table
          :data="tableData"
          border
          style="width: 100%">
        <el-table-column
            prop="certNo"
            label="证书编号"
            align="center"
            width="180">
        </el-table-column>
        <el-table-column
            prop="name"
            label="企业名称"
            align="center"
            width="180">
        </el-table-column>
        <el-table-column
            prop="productModel"
            align="center"
            label="产品型号">
        </el-table-column>
        <el-table-column
            prop="productName"
            align="center"
            label="产品名称">
        </el-table-column>
        <el-table-column
            prop="parameter"
            align="center"
            label="主要参数">
        </el-table-column>

        <el-table-column
            prop="issueDate"
            align="center"
            label="发证日期">
        </el-table-column>

        <template >
          <el-table-column
              align="center"
              label="证书">
            <template slot-scope="scope">
              <el-col :span="12" v-if="scope.row.frontImage">
                <el-image
                    style="width: 40px; height: 40px"
                    :src="$baseURL + scope.row.frontImage"
                    :preview-src-list="[$baseURL+scope.row.frontImage]">
                </el-image>
              </el-col>
              <el-col :span="12" v-else>
                <el-image
                    style="width: 40px; height: 40px"
                    src="/portal/images/white.jpg"
                    :preview-src-list="['/portal/images/white.jpg']">
                </el-image>
              </el-col>

              <el-col :span="12" v-if="scope.row.backImage">
                <el-image
                    style="width: 40px; height: 40px"
                    :src="$baseURL + scope.row.backImage"
                    :preview-src-list="[$baseURL + scope.row.backImage]">
                </el-image>
              </el-col>

              <el-col :span="12" v-else>
                <el-image
                    style="width: 40px; height: 40px"
                    src="/portal/images/white.jpg"
                    :preview-src-list="['/portal/images/white.jpg']">
                </el-image>
              </el-col>
            </template>
          </el-table-column>

        </template>

      </el-table>
    </ul>

    <ul class="newslist" v-if="stations.id == 1005010">
      <el-table
          :data="tableData"
          border
          style="width: 100%">
        <el-table-column
            prop="projcertcode"
            label="证书编号"
            align="center"
            >
        </el-table-column>
        <el-table-column
            prop="corpnamechin"
            label="企业名称"
            align="center"
            >
        </el-table-column>
        <el-table-column
            prop="provdate"
            align="center"
            label="获证日期">
        </el-table-column>
        <el-table-column
            prop="dealdate"
            align="center"
            label="证书到期日">
        </el-table-column>
        <el-table-column
            prop="typeName"
            align="center"
            label="体系类型">
        </el-table-column>

        <el-table-column
            prop="certstate"
            align="center"
            label="证书状态">
        </el-table-column>
        <el-table-column
            prop="certmark"
            align="center"
            label="状态">
        </el-table-column>

        <el-table-column
            prop="fanwei"
            align="center"
            label="证书范围">
        </el-table-column>

        <el-table-column
            prop="dizhi"
            align="center"
            label="企业地址">
        </el-table-column>
        <el-table-column
            prop="chandate"
            align="center"
            label="变更日期">
        </el-table-column>


      </el-table>
    </ul>

    <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
//证书公告模型组件

import {mapState} from 'vuex'

export default {
  props:{
    query:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  created() {
    if(this.$store.state.stations.id == '1004'){
      //发送请求
      this.getList(1)
    }
  },
  data(){
    return {
      tableData:[],
      pageNum: 1,
      pageSize: 10,
      total: 0,
    }
  },
  computed:{
    ...mapState(['stations'])
  },
  methods:{
    async  getList(type = 0) {
      // 创建 XMLHttpRequest 对象
      const xhr = new XMLHttpRequest();

      // 设置请求方法和URL
      const url = 'https://3coa.cccap.org.cn/do/manage/customer_cert/query1_cert/';
      xhr.open('POST', url, true);

      // 设置请求头
      xhr.setRequestHeader('Content-Type', 'application/json');

      // 准备要发送的数据
      const requestData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.query
      };

      // 返回一个Promise以便使用await
      return new Promise((resolve, reject) => {
        // 设置状态变化回调函数
        xhr.onreadystatechange = async function() {
          if (xhr.readyState === 4) { // 请求完成
            if (xhr.status === 200) { // 请求成功
              try {
                const res = JSON.parse(xhr.responseText);
                if (res.code === 200) {
                  // 请求成功且业务代码为200
                  this.tableData = res.data.list;
                  this.total = res.data.total;
                  resolve(res); // 解析Promise
                } else {
                  // 业务逻辑错误
                  await this.$msgbox(res.msg, '提示');
                  reject(res.msg); // 拒绝Promise
                }
              } catch (error) {
                // JSON解析错误
                reject('响应数据解析错误');
              }
            } else {
              // HTTP请求失败
              reject(`请求失败，状态码: ${xhr.status}`);
            }
          }
        }.bind(this); // 绑定this以确保上下文正确

        // 发送请求
        xhr.send(JSON.stringify(requestData));
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(1);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList(1);
    },
    getText(str){
      let res = str.replace(/[^\u4e00-\u9fa5]/gi, "")
      if(res.length > 80){
        res = res.slice(0,80) + '...'
      }
      return res
    },
    toDetail(id){
      this.$router.push(`/contents/${this.pid}/${this.columnId}/${id}.html`)
    }
  },
}
</script>

<style scoped>
ul{
  margin-bottom: 30px;
}
</style>
